/* eslint-disable @typescript-eslint/no-explicit-any */

import ChartSkeleton from '../skeleton/ChartSkeleton'
import { useEffect, useId, useState } from 'react'
import { AreaSplineChartData } from '../../types/StatTypes'
import BaseChart from './BaseChart'

interface IAreaSplineProps {
  chartData: AreaSplineChartData
}

const AreaSpline = (props: IAreaSplineProps) => {
  const { chartData } = props
  const [isLoading, setIsLoading] = useState(true)
  const chartId = useId()

  useEffect(() => {
    if (chartData != undefined) {
      setIsLoading(true)
      const timer = setTimeout(() => setIsLoading(false), 300)
      return () => clearTimeout(timer)
    }
  }, [chartData])

  const formattedSeries = chartData.series.map((s) => ({
    ...s,
    data: s.data.map(([dateStr, value]) => [new Date(dateStr).getTime(), value]),
  }))

  const options: any = {
    chart: {
      height: chartData.height || 200,
      type: 'areaspline',
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    legend: chartData.showLegend
      ? {
          layout: 'horizontal',
          align: 'left',
          verticalAlign: 'top',
          itemStyle: {
            color: chartData.textColor,
          },
          itemHoverStyle: {
            color: chartData.textColor,
          },
        }
      : {
          enabled: false,
        },
    xAxis: {
      type: 'datetime',
      title: {
        text: '',
      },
      labels: {
        style: {
          color: chartData.textColor,
        },
      },
      lineColor: chartData.textColor,
    },
    yAxis: {
      title: {
        text: '',
      },
      labels: {
        style: {
          color: chartData.textColor,
        },
      },
      gridLineColor: chartData.gridColor || '#E0E0E0',
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      areaspline: {
        fillOpacity: 0.5,
      },
    },
    series: formattedSeries,
  }

  // NewChart component moved outside AreaSpline

  return <>{isLoading ? <ChartSkeleton fullWidth={true} /> : <BaseChart options={options} id={chartId} />}</>
}

export default AreaSpline
